import { createAction } from 'redux-actions';

export const requestGetPartnerByIdAction = createAction('REQUEST/GET_PARTNER_BY_ID');

export const singlePartnerClear = createAction('SINGLE_PARTNER/CLEAR');

export const singlePartnerArchived = createAction('SINGLE_PARTNER/ARCHIVED');
